"use strict";
/**
 * RegisterExperiment and RegisterMultipleExperiments call this function to determine which bucket to use.
 *
 * @param assignedBucket assignedBucket returned from SplitTest API
 * @param hasErrored If the API call has errored
 * @param remainingCookieTime remining time till cookie expires
 * @param preloadedBucket bucket value set from the cookie
 * @param defaultBucket default bucket value
 * @returns {string}
 */
Object.defineProperty(exports, "__esModule", { value: true });
var determineBucketToUse = function (assignedBucket, hasErrored, remainingCookieTime, preloadedBucket, defaultBucket) {
    if (assignedBucket) {
        return assignedBucket;
    }
    if (hasErrored && remainingCookieTime && remainingCookieTime > 0) {
        return preloadedBucket || defaultBucket;
    }
    return defaultBucket;
};
exports.default = determineBucketToUse;
